// 메인화면(지역별 TOP 랭킹) 카테고리 메타 + 관리자 설정(표시/순서/형태) 저장.
// 관리자 '메인화면설정' 페이지와 MainTopRankings 가 공유하는 단일 소스.
//
// scope: 콤보박스로 선택 가능한 범위 레벨. 'region'(지역)/'dong'(생활권)/'danji'(단지)
//  - 상승율/하락율/레전드/매매가/투자금/거래량: 지역→생활권→단지 순차(단지 미선택 시 상위 집계)
//  - 투자추천: 지역/생활권 (단지 랭킹을 지역/생활권으로 필터)
//  - 적현율/고현율/저현율: 단지만
//  - 즐겨찾기: 단지(내 즐겨찾기)

export const MAIN_CATEGORIES = [
  {
    id: 'favorites', title: '즐겨찾기', color: '#0d9488', rankKey: 'favorites', defaultType: 'table',
    scope: ['danji'],
    columns: ['rank', 'name', 'region', 'grade', 'tradePrice', 'tradeReal', 'leasePrice', 'leaseReal', 'invest', 'articleCount', 'realCount', 'topPrice'],
    valueKind: 'price', chartNote: '매매 실거래가',
  },
  {
    id: 'investRec', title: '투자추천', color: '#0d9488', rankKey: 'invest', hasBudget: true, defaultType: 'table',
    scope: ['region', 'dong'],
    columns: ['rank', 'name', 'region', 'grade', 'tradePrice', 'tradeReal', 'leasePrice', 'leaseReal', 'invest', 'articleCount', 'realCount', 'topPrice', 'properHigh'],
    valueKind: 'invest', chartNote: '매매 실거래가',
  },
  {
    id: 'rise', title: '상승율', color: '#dc2626', rankKeyBase: 'rise', hasPeriod: true, defaultType: 'table',
    scope: ['region', 'dong', 'danji'], metricLabel: '상승율', metricFmt: 'pct',
    columns: ['rank', 'name', 'region', 'grade', 'rateOwn', 'tradePrice', 'prevTrade', 'tradeReal', 'invest', 'articleCount', 'realCount'],
    valueKind: 'rate', chartNote: '상승율',
  },
  {
    id: 'fall', title: '하락율', color: '#2563eb', rankKeyBase: 'fall', hasPeriod: true, defaultType: 'table',
    scope: ['region', 'dong', 'danji'], metricLabel: '하락율', metricFmt: 'pct',
    columns: ['rank', 'name', 'region', 'grade', 'rateOwn', 'tradePrice', 'prevTrade', 'tradeReal', 'invest', 'articleCount', 'realCount'],
    valueKind: 'rate', chartNote: '하락율',
  },
  {
    id: 'jeokHyun', title: '적현율', color: '#7c3aed', rankKey: 'jeokHyun', defaultType: 'table',
    scope: ['danji'], metricLabel: '적현율', metricFmt: 'rate',
    columns: ['rank', 'name', 'region', 'grade', 'rateOwn', 'properHigh', 'tradePrice', 'tradeReal', 'leasePrice', 'invest', 'articleCount'],
    valueKind: 'rate', chartNote: '적현율',
  },
  {
    id: 'goHyun', title: '고현율', color: '#c2410c', rankKey: 'goHyun', defaultType: 'table',
    scope: ['danji'], metricLabel: '고현율', metricFmt: 'rate',
    columns: ['rank', 'name', 'region', 'grade', 'rateOwn', 'topPrice', 'tradePrice', 'tradeReal', 'leasePrice', 'invest', 'articleCount'],
    valueKind: 'rate', chartNote: '고현율',
  },
  {
    id: 'jeoHyun', title: '저현율', color: '#0369a1', rankKey: 'jeoHyun', defaultType: 'table',
    scope: ['danji'], metricLabel: '저현율', metricFmt: 'rate',
    columns: ['rank', 'name', 'region', 'grade', 'rateOwn', 'lowPrice', 'tradePrice', 'tradeReal', 'leasePrice', 'invest', 'articleCount'],
    valueKind: 'rate', chartNote: '저현율',
  },
  {
    id: 'legend', title: '레전드', color: '#6366f1', rankKey: 'legend', defaultType: 'chart',
    scope: ['region', 'dong', 'danji'],
    columns: ['rank', 'name', 'region', 'grade', 'tradePrice', 'tradeReal', 'leasePrice', 'invest', 'leaseRate', 'articleCount'],
    valueKind: 'price', chartNote: '매매가/최고가',
  },
  {
    id: 'tradePrice', title: '매매가', color: '#2563eb', rankKey: 'tradePrice', defaultType: 'chart',
    scope: ['region', 'dong', 'danji'],
    columns: ['rank', 'name', 'region', 'grade', 'tradePrice', 'tradeReal', 'leasePrice', 'invest', 'leaseRate', 'articleCount'],
    valueKind: 'price', chartNote: '매매가',
  },
  {
    id: 'invest', title: '투자금', color: '#0d9488', rankKey: 'invest', hasBudget: true, defaultType: 'chart',
    scope: ['region', 'dong', 'danji'],
    columns: ['rank', 'name', 'region', 'grade', 'tradePrice', 'tradeReal', 'leasePrice', 'invest', 'leaseRate', 'articleCount'],
    valueKind: 'invest', chartNote: '매매가/투자금',
  },
  {
    id: 'volume', title: '거래량', color: '#f97316', rankKey: 'volume', hasPeriod: true, defaultType: 'chart',
    scope: ['region', 'dong', 'danji'],
    columns: ['rank', 'name', 'region', 'grade', 'tradePrice', 'tradeReal', 'leasePrice', 'invest', 'articleCount', 'realCount', 'txRatio'],
    valueKind: 'count', chartNote: '거래량',
  },
];

export const MAIN_CATEGORY_MAP = MAIN_CATEGORIES.reduce((acc, c) => { acc[c.id] = c; return acc; }, {});

// 기본 설정: 전체 표시 + 카테고리 기본 형태
// (즐겨찾기는 임시로 기본 숨김 — 로그인/즐겨찾기 연동 전까지. 관리자가 켤 수 있음)
export const buildDefaultMainScreenConfig = () =>
  MAIN_CATEGORIES.map((c) => ({ id: c.id, enabled: c.id !== 'favorites', type: c.defaultType }));

// 서버(main_screen_setting) 응답 rows → 화면 config([{id,enabled,type}])로 병합.
//  - display order = sort_order 오름차순
//  - 신규 카테고리는 뒤에 기본값으로 추가, 알 수 없는 id 는 제외
//  - rows 가 비면 전체 기본값
export const mergeSavedIntoConfig = (savedItems) => {
  const defaults = buildDefaultMainScreenConfig();
  const list = Array.isArray(savedItems) ? savedItems : [];
  if (list.length === 0) return defaults;
  const known = new Set(MAIN_CATEGORIES.map((c) => c.id));
  const rows = list
    .map((s) => ({
      id: s?.categoryId ?? s?.id,
      enabled: (s?.enabled ?? s?.Enabled) !== false,
      type: ((s?.displayType ?? s?.type) === 'chart') ? 'chart' : 'table',
      sortOrder: Number(s?.sortOrder ?? s?.SortOrder ?? 0),
    }))
    .filter((r) => known.has(r.id))
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map(({ id, enabled, type }) => ({ id, enabled, type }));
  const seen = new Set(rows.map((r) => r.id));
  defaults.forEach((d) => { if (!seen.has(d.id)) rows.push(d); });
  return rows;
};

// 화면 config([{id,enabled,type}]) → 서버 저장 payload rows
export const configToSaveItems = (config) =>
  (Array.isArray(config) ? config : []).map((c, i) => ({
    categoryId: c.id,
    enabled: c.enabled !== false,
    displayType: c.type === 'chart' ? 'chart' : 'table',
    sortOrder: i + 1,
  }));
